import { useRef } from 'react';

const CODE_LENGTH = 6;

export default function VerificationCodeInput({ value, onChange, id = 'verification-code' }) {
  const inputsRef = useRef([]);

  const digits = Array.from({ length: CODE_LENGTH }, (_, index) => value[index] || '');

  const focusInput = (index) => {
    const input = inputsRef.current[index];
    if (input) {
      input.focus();
      input.select();
    }
  };

  const setDigits = (nextDigits) => {
    onChange(nextDigits.join('').slice(0, CODE_LENGTH));
  };

  const handleChange = (index, rawValue) => {
    const cleaned = rawValue.replace(/\D/g, '');

    if (cleaned.length > 1) {
      const pasted = cleaned.slice(0, CODE_LENGTH);
      const next = Array.from({ length: CODE_LENGTH }, (_, i) => pasted[i] || '');
      setDigits(next);
      focusInput(Math.min(pasted.length, CODE_LENGTH - 1));
      return;
    }

    const next = [...digits];
    next[index] = cleaned.slice(-1);
    setDigits(next);

    if (cleaned && index < CODE_LENGTH - 1) {
      focusInput(index + 1);
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === 'Backspace' && !digits[index] && index > 0) {
      focusInput(index - 1);
      return;
    }

    if (event.key === 'ArrowLeft' && index > 0) {
      event.preventDefault();
      focusInput(index - 1);
      return;
    }

    if (event.key === 'ArrowRight' && index < CODE_LENGTH - 1) {
      event.preventDefault();
      focusInput(index + 1);
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const pasted = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, CODE_LENGTH);
    if (!pasted) return;

    const next = Array.from({ length: CODE_LENGTH }, (_, i) => pasted[i] || '');
    setDigits(next);
    focusInput(Math.min(pasted.length, CODE_LENGTH - 1));
  };

  return (
    <div className="auth-otp-field">
      <label className="cds--label" htmlFor={`${id}-0`}>
        Verification code
      </label>
      <div className="auth-otp-inputs" onPaste={handlePaste}>
        {digits.map((digit, index) => (
          <input
            key={index}
            ref={(element) => {
              inputsRef.current[index] = element;
            }}
            id={`${id}-${index}`}
            className="auth-otp-digit"
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            autoComplete={index === 0 ? 'one-time-code' : 'off'}
            maxLength={1}
            value={digit}
            onChange={(event) => handleChange(index, event.target.value)}
            onKeyDown={(event) => handleKeyDown(index, event)}
            aria-label={`Digit ${index + 1} of ${CODE_LENGTH}`}
          />
        ))}
      </div>
      <p className="auth-otp-help">Enter the 6-digit code from your email.</p>
    </div>
  );
}
